var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopiedCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 30C7 29.447 6.553 29 6 29H1C0.447 29 0 29.447 0 30C0 30.553 0.447 31 1 31H6C6.553 31 7 30.553 7 30Z",
    fill: "#ADF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.716 41.1342L4.386 43.6342C3.907 43.9102 3.743 44.5222 4.02 45.0002C4.206 45.3212 4.541 45.5002 4.887 45.5002C5.057 45.5002 5.229 45.4572 5.386 45.3662L9.716 42.8662C10.195 42.5902 10.359 41.9782 10.082 41.5002C9.805 41.0212 9.192 40.8582 8.716 41.1342Z",
    fill: "#125454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 49.9182C18.021 49.6422 17.411 49.8062 17.134 50.2842L14.634 54.6142C14.358 55.0932 14.522 55.7042 15 55.9802C15.157 56.0712 15.329 56.1142 15.499 56.1142C15.845 56.1142 16.181 55.9342 16.366 55.6142L18.866 51.2842C19.142 50.8052 18.978 50.1942 18.5 49.9182Z",
    fill: "#F18F01",
    fillOpacity: 0.941176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 53C29.447 53 29 53.447 29 54V59C29 59.553 29.447 60 30 60C30.553 60 31 59.553 31 59V54C31 53.447 30.553 53 30 53Z",
    fill: "#F374AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.866 50.2839C42.589 49.8049 41.975 49.6409 41.5 49.9179C41.021 50.1939 40.857 50.8059 41.134 51.2839L43.634 55.6139C43.82 55.9349 44.155 56.1139 44.501 56.1139C44.671 56.1139 44.843 56.0709 45 55.9799C45.479 55.7039 45.643 55.0919 45.366 54.6139L42.866 50.2839Z",
    fill: "#ADF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.614 43.6338L51.284 41.1338C50.806 40.8588 50.194 41.0208 49.918 41.4998C49.642 41.9788 49.806 42.5898 50.284 42.8658L54.614 45.3658C54.771 45.4568 54.943 45.4998 55.113 45.4998C55.459 45.4998 55.795 45.3208 55.98 44.9998C56.256 44.5208 56.092 43.9098 55.614 43.6338Z",
    fill: "#133751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 29H54C53.447 29 53 29.447 53 30C53 30.553 53.447 31 54 31H59C59.553 31 60 30.553 60 30C60 29.447 59.553 29 59 29Z",
    fill: "#F18F01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.785 19.0002C50.955 19.0002 51.127 18.9572 51.284 18.8662L55.614 16.3662C56.093 16.0902 56.257 15.4782 55.98 15.0002C55.704 14.5212 55.09 14.3562 54.614 14.6342L50.284 17.1342C49.805 17.4102 49.641 18.0222 49.918 18.5002C50.104 18.8212 50.439 19.0002 50.785 19.0002Z",
    fill: "#F374AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 4.01976C44.521 3.74376 43.91 3.90776 43.634 4.38576L41.134 8.71576C40.858 9.19476 41.022 9.80576 41.5 10.0818C41.657 10.1728 41.829 10.2158 41.999 10.2158C42.345 10.2158 42.681 10.0358 42.866 9.71576L45.366 5.38576C45.642 4.90676 45.478 4.29576 45 4.01976Z",
    fill: "#ADF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 7C30.553 7 31 6.553 31 6V1C31 0.447 30.553 0 30 0C29.447 0 29 0.447 29 1V6C29 6.553 29.447 7 30 7Z",
    fill: "#125454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.134 9.71594C17.32 10.0369 17.655 10.2159 18.001 10.2159C18.171 10.2159 18.343 10.1729 18.5 10.0819C18.979 9.80594 19.143 9.19394 18.866 8.71594L16.366 4.38594C16.09 3.90694 15.476 3.74294 15 4.01994C14.521 4.29594 14.357 4.90794 14.634 5.38594L17.134 9.71594Z",
    fill: "#F18F01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.716 17.1342L5.386 14.6342C4.907 14.3572 4.296 14.5212 4.02 15.0002C3.744 15.4792 3.908 16.0902 4.386 16.3662L8.716 18.8662C8.873 18.9572 9.045 19.0002 9.215 19.0002C9.561 19.0002 9.897 18.8212 10.082 18.5002C10.358 18.0212 10.194 17.4102 9.716 17.1342Z",
    fill: "#F374AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.199 17.3988C42.336 16.7528 41.048 16.9348 40.399 17.7998C40.374 17.8338 24.474 39.0318 24.474 39.0318C24.3 39.2638 24.035 39.4088 23.745 39.4288C23.447 39.4548 23.172 39.3438 22.967 39.1388L17.413 33.5848C16.639 32.8108 15.357 32.8118 14.585 33.5848C14.207 33.9628 13.999 34.4648 13.999 34.9988C13.999 35.5328 14.207 36.0348 14.585 36.4128L22.585 44.4128C22.963 44.7908 23.465 44.9988 23.999 44.9988L24.144 44.9928C24.72 44.9528 25.251 44.6628 25.598 44.1988L43.599 20.1988C44.248 19.3318 44.069 18.0498 43.198 17.3978L43.199 17.3988Z",
    fill: "#58B142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopiedCheckmark);
export default __webpack_public_path__ + "static/media/copied-checkmark.e33302b0deece2be663504cd45e0dddf.svg";
export { ForwardRef as ReactComponent };